export default "__VITE_ASSET__DYOmENj9__"